// src/components/PeoplePlan/TheBench/hooks/useWorkflowSelection.js
import { useState } from 'react';

const useWorkflowSelection = () => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  // Checkbox handling - properly updates selectedEmployees state
  const handleCheckboxChange = (userId, checked) => {
    console.log("Checkbox changed. User ID:", userId, "Checked:", checked);

    setSelectedEmployees((prev) => {
      if (checked) {
        // Add to selected if not already present
        return prev.includes(userId) ? prev : [...prev, userId];
      } else {
        // Remove from selected
        return prev.filter((id) => id !== userId);
      }
    });
  };

  // Clear all selections
  const clearSelection = () => {
    setSelectedEmployees([]);
  };

  // Check if an employee is selected
  const isSelected = (userId) => {
    return selectedEmployees.includes(userId);
  };

  // Select all employees
  const selectAll = (employeeIds) => {
    setSelectedEmployees(employeeIds);
  };

  // Get selection count
  const getSelectionCount = () => {
    return selectedEmployees.length;
  };

  return {
    selectedEmployees,
    handleCheckboxChange,
    clearSelection,
    isSelected,
    selectAll,
    getSelectionCount
  };
};

export default useWorkflowSelection;